import { Injectable } from '@angular/core';

import { BaseProductApi } from '../../BaseProductApi';
import { IDeltacastCatalogIdentificationMapping } from '../../../../model/product/tena/deltacast/IDeltacastCatalogIdentificationMapping.d';

@Injectable()
export class DeltacastCatalogIdentificationMappingApi extends BaseProductApi<
IDeltacastCatalogIdentificationMapping
> {
    protected getBaseUrl() {
        return super.getBaseUrl() + 'hmscountrytoidentificationsourcemapping/deltacast';
    }
}
